import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SegmentFormFragmentDoc } from '../../features/segment/components/SegmentForm/SegmentForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type LineRichMenuNewPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LineRichMenuNewPageQuery = { __typename?: 'Query', segmentConditionParameters: { __typename?: 'SegmentConditionParameters', enqueteAnsweredCondition: { __typename?: 'SegmentConditionParameter_EnqueteAnswered', enquetes: Array<{ __typename?: 'SegmentConditionParameter_EnqueteAnswered_Enquete', guid: string, title: string }> }, inflowSourceCondition: { __typename?: 'SegmentConditionParameter_InflowSource', inflowSources: Array<{ __typename?: 'UserRegistrationInflowSourceDefinition', guid: string, inflowSourceName: string }> }, clickURLCondition: { __typename?: 'SegmentConditionParameter_ClickURL', clickUrls: Array<{ __typename?: 'SegmentConditionParameter_ClickURL_URL', guid: string, url: string }> }, userVariableDefinitionCondition: { __typename?: 'SegmentConditionParameter_UserVariableDefinition', userVariableDefinitions: Array<{ __typename?: 'UserVariableDefinition', guid: string, name: string, value: { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ __typename?: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> } | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ __typename?: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> } | { __typename?: 'UserVariableDefinitionValueString' } | { __typename?: 'UserVariableDefinitionValueText' } }> } } };

export type CreateLineRichMenuMutationVariables = Types.Exact<{
  input: Types.CreateLineRichMenuInput;
}>;


export type CreateLineRichMenuMutation = { __typename?: 'Mutation', createLineRichMenu: { __typename?: 'CreateLineRichMenuSuccessPayload', lineRichMenu: { __typename?: 'LineRichMenu', guid: string, label: string, status: Types.LineRichMenuStatus, templateName: string, backgroundImageFileName: string, chatBarText: string, isDisplayDefault: boolean, targetType: Types.TargetType, templateActions: Array<{ __typename: 'LineRichMenuTemplateAction', panelName: string, actionType: Types.LineRichMenuActionType, url?: string | null, label?: string | null, text?: string | null }>, segment?: { __typename?: 'Segment', conditions: Array<{ __typename: 'SegmentConditionClickURLCondition' } | { __typename: 'SegmentConditionEnqueteAnswered' } | { __typename: 'SegmentConditionInflowSource' } | { __typename: 'SegmentConditionLoginLink' } | { __typename: 'SegmentConditionRoomStatus' }> } | null } } | { __typename?: 'LineRichMenuErrorPayload', reason: Types.LineRichMenuErrorReason } };


export const LineRichMenuNewPageDocument = gql`
    query LineRichMenuNewPage {
  ...SegmentForm
}
    ${SegmentFormFragmentDoc}`;

/**
 * __useLineRichMenuNewPageQuery__
 *
 * To run a query within a Vue component, call `useLineRichMenuNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineRichMenuNewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineRichMenuNewPageQuery();
 */
export function useLineRichMenuNewPageQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>(LineRichMenuNewPageDocument, {}, options);
}
export function useLineRichMenuNewPageLazyQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>(LineRichMenuNewPageDocument, {}, options);
}
export type LineRichMenuNewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineRichMenuNewPageQuery, LineRichMenuNewPageQueryVariables>;
export const CreateLineRichMenuDocument = gql`
    mutation CreateLineRichMenu($input: CreateLineRichMenuInput!) {
  createLineRichMenu(input: $input) {
    ... on CreateLineRichMenuSuccessPayload {
      lineRichMenu {
        guid
        label
        status
        templateName
        backgroundImageFileName
        templateActions {
          __typename
          panelName
          actionType
          url
          label
          text
        }
        chatBarText
        isDisplayDefault
        targetType
        segment {
          conditions {
            __typename
          }
        }
      }
    }
    ... on LineRichMenuErrorPayload {
      reason
    }
  }
}
    `;

/**
 * __useCreateLineRichMenuMutation__
 *
 * To run a mutation, you first call `useCreateLineRichMenuMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateLineRichMenuMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateLineRichMenuMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateLineRichMenuMutation(options: VueApolloComposable.UseMutationOptions<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables>(CreateLineRichMenuDocument, options);
}
export type CreateLineRichMenuMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateLineRichMenuMutation, CreateLineRichMenuMutationVariables>;